import { breadcrumbTrail } from './breadcrumbTrail';
import { textProp } from './elementProps';
import { useElementBox, useElementRender, type ElementComponent } from './elementRenderContext';

import './elementProductPage.css';
import { useShopNames } from '../../commerce/shopNames';

// Draws the trail back from this page as an ordered list, the page itself marked as the current one.
export const BreadcrumbsElement: ElementComponent = ({ node }) => {
  const box = useElementBox(node);
  const { store } = useElementRender();
  const names = useShopNames();
  const steps = breadcrumbTrail(store, textProp(node.props, 'homeLabel', 'Home'));
  const separator = textProp(node.props, 'separator', '›');
  return (
    <nav {...box} aria-label={names.breadcrumb} className={[box.className, 'xe-crumbs'].filter(Boolean).join(' ')}>
      <ol>
        {steps.map((step, index) => (
          <li key={`${index}-${step.label}`}>
            {index > 0 && <span aria-hidden="true" className="xe-crumbs-sep">{separator}</span>}
            {step.href ? <a href={step.href} dir="auto">{step.label}</a> : <span aria-current="page" dir="auto">{step.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};
